import React, { useEffect, useState } from "react";
import TestDefault from "./default/TestDefault";
import TestIIT from "./iit/TestIIT";
import { useLanguages } from "../../context/LanguagesContext";
import { useQuestion } from "../../context/QuestionsContext";
import { useProfile } from "../../context/ProfileContext";
import { useNavigate } from "react-router-dom";
import ROUTES_NAME from "../../constants/RoutesName";
import GateTest from "./gate/GateTest";
import internetIssue from "../../images/internetissue.jpeg";
import { decryptData } from "../../crypto";
import { useMediaQuery } from "@mui/material";
import Loader from "../../components/Loader";
import FeedbackTest from "./feedback/FeedbackTest";
import IpMat from '../test/ipmat/GateTest'
import CodingWorkspace from '../test/coding/CodingWorkspace'


function Test({}) {
  const { fetchProfileData } = useProfile();
  const { fetchQuestions } = useQuestion();
  const { fetchLanguagesData } = useLanguages();
  const [isOffline, setIsOffline] = useState(false);
  const isDesktop = useMediaQuery("(min-width:768px)");
  const isMobile = useMediaQuery("(max-width:599px)");
  const isTablet = useMediaQuery("(min-width:600px) and (max-width:768px)");

  const navigate = useNavigate();

  useEffect(() => {
    fetchProfileData();
  }, []);

  useEffect(() => {
    const examId = sessionStorage.getItem("examId");
    if (examId) {
      fetchQuestions(examId);
      fetchLanguagesData(examId);
    }
  }, []);

  useEffect(() => {
    const checkAuth = () => {
      let isBackForward = false;
      
      // Use Performance API to detect if they arrived via Browser Back/Forward buttons from another site
      const navEntries = performance.getEntriesByType("navigation");
      if (navEntries.length > 0 && navEntries[0].type === "back_forward") {
        isBackForward = true;
      }

      const examToken = sessionStorage.getItem("examToken");
      const userName = sessionStorage.getItem("userName");
      const examStarted = sessionStorage.getItem("examStarted");

      // If they used the Forward arrow from outside, we wipe their storage as requested
      if (isBackForward) {
        localStorage.clear();
        sessionStorage.clear();
        navigate(ROUTES_NAME.LOGIN, { replace: true });
        window.location.reload();
        return;
      }

      if (!examToken || !userName || !examStarted) {
        // If tokens are genuinely missing (e.g. logged out), kick them to Login
        navigate(ROUTES_NAME.LOGIN, { replace: true });
      }
    };

    // Check immediately on mount
    checkAuth();

    // Re-check authentication when restored from BFCache
    const handlePageShow = (e) => {
      if (e.persisted) checkAuth();
    };

    // Re-check when the tab becomes active again
    const handleVisibility = () => {
      if (document.visibilityState === "visible") checkAuth();
    };

    window.addEventListener("pageshow", handlePageShow);
    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [navigate]);

  useEffect(() => {
    function handleOffline() {
      setIsOffline(true);
    }
    function handleOnline() {
      setIsOffline(false);
    }
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);
    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  // Aggressive lock to prevent multiple rapid back-clicks from escaping
  useEffect(() => {
    // Push a double buffer so rapid clicks hit our trap twice
    window.history.pushState(null, "", window.location.href);
    window.history.pushState(null, "", window.location.href);

    const handlePopState = (event) => {
      // Trap the back action and immediately re-push the current state
      window.history.pushState(null, "", window.location.href);
      // Force React Router to remain on the test route
      navigate(ROUTES_NAME.TEST, { replace: true });
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  const componentMap = {
    // iit: <TestIIT />,
    iit: <TestIIT />,
    "ssc/railway": <GateTest />,
    "coding": <CodingWorkspace />,
    ipmat: <IpMat />,
    // default: <TestDefault />,
    default: <FeedbackTest />,
  };

  const getComponentType = () => {
    // if (isMobile || isTablet) {
    //   return "default";
    // } else {
    //   return decryptData(sessionStorage.getItem("exam_template")) || "";
    // }
    return decryptData(sessionStorage.getItem("exam_template")) || "";
  };

  const type = getComponentType();

  return isOffline ? (
    <div style={{ textAlign: "center", marginTop: "2%" }}>
      <img src={internetIssue} alt="Internet Issue" />
    </div>
  ) : (
    componentMap[type] || <Loader />
  );
}

export default Test;
